import { ButtonSize, ButtonLevel } from '@zipari/shared-ds-util-button';

export type ButtonToggleStyle = 'button' | 'toggle';

export interface ButtonToggleOption {
  content: string;
  icon?: string;
  isIconRight?: boolean;
}

export interface ButtonToggleConfig {
  selected: ButtonToggleOption;
  unselected: ButtonToggleOption;
  style: ButtonToggleStyle;
  size?: ButtonSize;
  level?: ButtonLevel;
}

export interface ButtonToggleArgs {
  config: ButtonToggleConfig;
  isSelected: boolean;

  buttonToggleClicked?: (value: boolean) => void;
}
